import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import AuthenticatedRoutes from './AuthenticatedRoutes';
import UnauthenticatedRoutes from './UnauthenticatedRoutes';
import { withRouter, Redirect } from 'react-router-dom';
import { OnRouteChange, LogoutAction } from '../actions';
import ActionCableProvider from 'react-actioncable-provider'
import ActionCable from 'actioncable'
import { API_URL } from '../constants'
import CableConnection from '../CableConnection';

class RoutingMiddleware extends React.Component {
  constructor(props) {
    super(props);
    this.firstLoggedIn = localStorage.getItem("is_first_login");
  }

  componentDidMount() {
    this.props.OnRouteChange(this.props.location.pathname)
    this.props.history.listen(route => {
      this.props.OnRouteChange(route.pathname)
    })

    window.addEventListener("storage", e => {
      if (e.newValue === null)
        this.props.LogoutAction()
    }
    );

    window.addEventListener("load", (e) => {
      if (document.cookie.indexOf('mycookie') === -1) {
        document.cookie = "mycookie=1"
        this.props.LogoutAction()
      }
    });

  }

  render() {
    const accessToken = localStorage.getItem("access-token")
    const uid = localStorage.getItem("uid")
    const client = localStorage.getItem("client")
    const cableUrl = `${API_URL}/cable`;
    const consumer = ActionCable.createConsumer(`${cableUrl}?token=${accessToken}&uid=${uid}&client=${client}`);

    if (this.props.is_logged_in) {
      return (
        <Fragment>
          <ActionCableProvider cable={consumer}>
          <AuthenticatedRoutes />
          <CableConnection />
          </ActionCableProvider>
        </Fragment>
      )
    }
    return (
      <Fragment>
        <UnauthenticatedRoutes />
      </Fragment>)
  }


}

const mapStateToProps = state => {
  const { is_logged_in } = state.login;
  return {
    is_logged_in
  }
}

export default withRouter(connect(
  mapStateToProps,
  {
    OnRouteChange,
    LogoutAction
  }
)(RoutingMiddleware))

